module.exports = __webpack_public_path__ + "static/fonts/Mont-ExtraLight.2580442.woff2";